<template>
  <VModal ref="modal" @close="$emit('close')">
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-5xl sm:w-full h-full">
      <div class="flex flex-col h-full divide-y">
        <div class="flex-none p-4">Select metrics to apply</div>
        <div class="flex-none p-4">
          <MetricFilter v-model="inputFilters" />
        </div>
        <div class="flex-1 h-0">
          <div class="flex h-full">
            <div class="w-64 h-full bg-gray-100 rounded-l-lg">
              <div class="h-full overflow-y-auto fancy-scrollbar px-4 py-6">
                <CategorySelector
                  v-model="category"
                  :options="categories"
                  :meta-by-category="metaByCategory"
                />
              </div>
            </div>
            <div class="flex-1 h-full rounded-r-lg">
              <div class="h-full overflow-y-auto fancy-scrollbar p-4">
                <MetricSelector v-model="inputMetrics" :options="categoryMetricsFiltered" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex-none p-4 space-x-2">
          <BaseButton primary @click="applyMetrics"> Apply metrics </BaseButton>
          <BaseButton primary outline @click="clearMetrics"> Clear </BaseButton>
          <BaseButton ghost @click="$refs.modal.close()"> Cancel </BaseButton>
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import { intersection } from 'lodash-es';
import { metrics, metricsByCategory } from '@/utils/facebook-page-insights-query-params';
import CategorySelector from './facebook-page-insight-metrics-modal/category-selector.vue';
import MetricSelector from './facebook-page-insight-metrics-modal/metric-selector.vue';
import MetricFilter from './facebook-page-insight-metrics-modal/metric-filter.vue';

export default {
  components: {
    CategorySelector,
    MetricSelector,
    MetricFilter,
  },
  props: {
    period: {
      type: String,
      default: '',
    },
    metrics: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      category: 0,
      inputMetrics: [],
      inputFilters: [],
      metricsByCategory: [...metricsByCategory],
    };
  },
  computed: {
    categories() {
      return this.metricsByCategory.map((category, index) => ({
        label: category.label,
        value: index,
      }));
    },
    categoryMetrics() {
      const category = JSON.parse(JSON.stringify(this.metricsByCategory[this.category]));
      return category.metrics.map((metric) => metrics[metric]);
    },
    metaByCategory() {
      return this.metricsByCategory.reduce((carry, category, index) => {
        const metricValuesIncluded = intersection(category.metrics, this.inputMetrics);
        const categoryMetrics = category.metrics.map((metric) => metrics[metric]);

        return {
          ...carry,
          [index]: {
            totalCount: this.getOptionsFiltered(categoryMetrics).length,
            totalSelectedCount: metricValuesIncluded.length,
          },
        };
      }, {});
    },
    categoryMetricsFiltered() {
      if (!this.period) {
        return this.categoryMetrics;
      }

      return this.getOptionsFiltered(this.categoryMetrics);
    },
  },
  created() {
    this.inputMetrics = [...this.metrics];
  },
  methods: {
    getOptionsFiltered(targetMetrics) {
      return targetMetrics
        .filter((metric) => {
          if (!this.period) {
            return true;
          }

          return metric.periods.indexOf(this.period) >= 0;
        })
        .filter((metric) => {
          if (!this.inputFilters.length) {
            return true;
          }

          const metricParts = metric.value.split('_');

          const filtersExist = intersection(metricParts, this.inputFilters);

          return filtersExist.length > 0;
        });
    },
    clearMetrics() {
      this.inputMetrics = [];
    },
    applyMetrics() {
      this.$emit('apply', [...this.inputMetrics]);
      this.$refs.modal.close();
    },
  },
};
</script>
